import { Link } from "react-router-dom";
import shopLogo from "../../resources/images/app/ic_icon.png";
const NavbarLogo = () => {
  const isMobileWidth = window.innerWidth < 768;
  return (
    <Link to="/" className=" flex justify-center items-center mx-auto w-full ">
      {isMobileWidth ? (
        <div className="flex justify-center items-center self-center gap-2 whitespace-nowrap">
          <div className="flex flex-col items-center leading-tight">
            <h1 className="font-black text-lg antialiased tracking-tight">
              میوه کانی
            </h1>
            <span className="text-[10px] font-normal text-slate-500">
              تازه، سالم و با کیفیت
            </span>
          </div>
          <img src={shopLogo} alt="" className="h-9 w-9" />
        </div>
      ) : (
        <div className="relative w-full  flex flex-col justify-center items-center self-center text-xl font-semibold whitespace-nowrap">
          {/* <h1 className="font-black text-2xl antialiased tracking-tight">
            میوه کانی
          </h1> */}
          <div className="absolute -top-2.5">
            <img src={shopLogo} alt="" className="h-16" />
          </div>
        </div>
      )}
    </Link>
  );
};

export default NavbarLogo;
